import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { Bibliography, IBibliography } from './Bibliography';
import { ILocalBibliography, LocalBibliography } from './LocalBibliography';

export interface ILessonBibliography extends IEntity {
  attributes: {
    id: EntityStringId;
  };
  associations: {
    bibliography: IBibliography | null;
    localBibliography: ILocalBibliography | null;
  };
}

export type LessonBibliography = Entity<ILessonBibliography>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonBibliography: IEntityType<ILessonBibliography> = vmClient.defineClass({
  typeName: 'LessonBibliography',
  version: 1,
  lockable: true,
  persisted: true,
  associations: {
    bibliography: {
      type: Bibliography,
      shared: true,
    },
    localBibliography: LocalBibliography,
  },
});
